import classNames from 'classnames'
import React from 'react'
import styles from './HighlightText.module.scss'

export interface HighlightTextProps {
  text: string
  color?: 'default' | 'brand'
  size?: 'small' | 'medium' | 'large'
  textClass?: string
}

export const HighlightText: React.FC<HighlightTextProps> = ({
  text,
  color = 'default',
  size = 'xsmall',
  textClass = '',
}) => (
  <mark
    className={classNames(
      styles.highlight,
      styles[`highlight--${color}`],
      styles[`highlight--${size}`]
    )}
  >
    <span className={textClass}>{text}</span>
  </mark>
)
